export const TeamList = [
        
        {       
                name: "Carlos Alberto da Silva Júnior ", post: "Carlos.post", description: "Carlos.description", img:"/img/Carlos.jpeg", curriculum:"https://lattes.cnpq.br/8552305760747009"},
        {
                name:  "Afonso Serafim Jacinto ", post: "Afonso.post", description: "Afonso.description", img:"/img/Afonso.PNG", curriculum:"http://lattes.cnpq.br/1535037984412459"
        }, 
        {
                name: "Daiane Dantas da Silva", post: "Member.post", description: "Member.Daiane", img:"/img/Daiane.PNG", curriculum:"https://lattes.cnpq.br/6831782165818587",
        },
        {
                name: "Denilson Santos Alves", post: "Member.post", description: "Member.Denilson",
                img:"/img/Denilson.PNG", curriculum: "https://lattes.cnpq.br/7932715152047559",
        },
        {
                name: "Jefferson da Rocha Teodoro", post: "Member.post", description: "Member.Jefferson", img:"/img/Jefferson.PNG", curriculum: "http://lattes.cnpq.br/3099256114992204"
        },
        {
                name:"Jaelson Marques Martins", post: "Member.post", description: "Member.Jaelson", img:"/img/Jaelson.PNG", curriculum:" http://lattes.cnpq.br/0057145569854119"
        },
        {
                name: "Lucas de Sá Batista", post: "Member.post", description:"Member.Lucas", 
                img:"/img/Lucas.PNG" , curriculum: "http://lattes.cnpq.br/6771748788291885"
        },
        {
                name: "Francisco Tavares Pedrosa Júnior ", post: "Member.post", description: "Member.Tavares", img: "/img/Tavares.PNG", curriculum: "http://lattes.cnpq.br/7030009945500460", 
        },
        {
                name: "José Guilherme Gomes Queiroz", post: "Member.post", description: "Member.Guilherme",img: "/img/Guilherme.PNG", curriculum:"http://lattes.cnpq.br/1130339911285532"
        },
        {
                name: "Carlos Eduardo Nicioli", post: "Member.post", description: "Member.Nicioli", img:"/img/Nicioli.PNG", 
                curriculum: "http://lattes.cnpq.br/6988146314907398"
        },
        {
                name: "Aluisio Alonso Lopes Tomas", post: "Member.post", description: "Member.Aluisio", img:"/img/Aluisio.PNG", 
                curriculum: "http://lattes.cnpq.br/6988146314907398"
        },{
                name: "Francisco André Martins Pamplona Filho", post: "Member.post", description: "Member.Andre", img:"/img/Andre.png", curriculum: "http://lattes.cnpq.br/6120737731509483"
        },
        {
                name: "Emanuel Franklyn de Lima Maciel", post: "Member.post", description:"Member.Emanuel", img: "/img/Emanuel.png", curriculum: "https://lattes.cnpq.br/8212614765208145"
        },
        {
                name: "José Lucas da Costa Campos", post: "Member.post", description: "Member.Jose",
                img: "/img/Jose.png", curriculum: "http://lattes.cnpq.br/6771748788291885"
        },
        {
                name: "José Renato Gomes Lopes", post: "Member.post", description: "Member.Renato", img: "/img/Renato.png", curriculum: "http://lattes.cnpq.br/9345615314661286"       
        }
];